var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	92769: () => (loadSingletonVersion("default", "react", true, [1,18,2,0], () => (() => (__webpack_require__(96540))))),
	59783: () => (loadSingletonVersion("default", "react-dom", true, [1,18,2,0], () => (() => (__webpack_require__(40961))))),
	19655: () => (loadStrictVersion("default", "@datadog/browser-rum", true, [1,6,21,2], () => (() => (__webpack_require__(48953))))),
	40565: () => (loadSingletonVersion("default", "@tanstack/react-query", true, [1,5,62,7], () => (() => (__webpack_require__(85946))))),
	64646: () => (loadSingletonVersion("default", "@emotion/styled", false, [1,11,14,1], () => (Promise.all([__webpack_require__.e(1479), __webpack_require__.e(4905)]).then(() => (() => (__webpack_require__(71479))))))),
	14249: () => (loadStrictVersion("default", "@mui/x-license", false, [4,7,29,1], () => (__webpack_require__.e(2608).then(() => (() => (__webpack_require__(20227))))))),
	2054: () => (loadStrictVersion("default", "react-use-measure", false, [1,2,1,1], () => (__webpack_require__.e(4688).then(() => (() => (__webpack_require__(34688))))))),
	3701: () => (loadSingletonVersion("default", "react-router-dom", true, [1,6,21,1], () => (() => (__webpack_require__(92648))))),
	12955: () => (loadSingletonVersion("default", "@openfeature/react-sdk", true, [2,0,4,11], () => (() => (__webpack_require__(89663))))),
	27163: () => (loadSingletonVersion("default", "@mui/x-date-pickers", false, [1,8,19,0], () => (Promise.all([__webpack_require__.e(2136), __webpack_require__.e(9447), __webpack_require__.e(9863), __webpack_require__.e(4905)]).then(() => (() => (__webpack_require__(59863))))))),
	30431: () => (loadStrictVersion("default", "dayjs", false, [1,1,11,13], () => (__webpack_require__.e(4353).then(() => (() => (__webpack_require__(74353))))))),
	37137: () => (loadStrictVersion("default", "react-idle-timer", false, [1,5,7,2], () => (__webpack_require__.e(7087).then(() => (() => (__webpack_require__(7087))))))),
	48173: () => (loadStrictVersion("default", "classnames", false, [1,2,5,1], () => (__webpack_require__.e(2485).then(() => (() => (__webpack_require__(32485))))))),
	53638: () => (loadSingletonVersion("default", "zustand", true, [1,4,5,2], () => (() => (__webpack_require__(34085))))),
	54673: () => (loadSingletonVersion("default", "zone.js", false, [2,0,14,3], () => (__webpack_require__.e(8216).then(() => (() => (__webpack_require__(38216))))))),
	63345: () => (loadStrictVersion("default", "react-helmet-async", false, [1,2,0,5], () => (Promise.all([__webpack_require__.e(5902), __webpack_require__.e(3824)]).then(() => (() => (__webpack_require__(85902))))))),
	67868: () => (loadStrictVersion("default", "usehooks-ts", false, [1,3,1,0], () => (__webpack_require__.e(5103).then(() => (() => (__webpack_require__(65103))))))),
	78626: () => (loadSingleton("default", "@cocounsel/prometheus", true, () => (() => (__webpack_require__(10119))))),
	78721: () => (loadStrictVersion("default", "@saffron/core-components", false, [1,3,0,0], () => (__webpack_require__.e(1997).then(() => (() => (__webpack_require__(21997))))))),
	86843: () => (loadStrictVersion("default", "react-hook-form", false, [1,7,51,0], () => (__webpack_require__.e(7286).then(() => (() => (__webpack_require__(97286))))))),
	87242: () => (loadStrictVersion("default", "axios", false, [1,1,13,6], () => (__webpack_require__.e(1914).then(() => (() => (__webpack_require__(31914))))))),
	98283: () => (loadSingleton("default", "@cocounsel/prometheus/material", true, () => (() => (__webpack_require__(14141))))),
	54905: () => (loadSingletonVersion("default", "@emotion/react", false, [1,11,13,3], () => (__webpack_require__.e(9646).then(() => (() => (__webpack_require__(19646))))))),
	57586: () => (loadStrictVersion("default", "date-fns", false, [1,4,1,0], () => (Promise.all([__webpack_require__.e(9185), __webpack_require__.e(3873)]).then(() => (() => (__webpack_require__(93873))))))),
	13824: () => (loadStrictVersion("default", "react-fast-compare", false, [1,3,2,2], () => (__webpack_require__.e(115).then(() => (() => (__webpack_require__(30115))))))),
	37172: () => (loadStrictVersion("default", "postcss", false, [1,8,2,1], () => (Promise.all([__webpack_require__.e(2418), __webpack_require__.e(1445)]).then(() => (() => (__webpack_require__(2418))))))),
	89771: () => (loadStrictVersion("default", "@mui/x-data-grid-premium", false, [1,7,18,0], () => (Promise.all([__webpack_require__.e(2136), __webpack_require__.e(4197), __webpack_require__.e(4905)]).then(() => (() => (__webpack_require__(4197))))))),
	6883: () => (loadSingletonVersion("default", "date-fns-tz", false, [1,3,2,0], () => (__webpack_require__.e(3797).then(() => (() => (__webpack_require__(13797))))))),
	82129: () => (loadStrictVersion("default", "react-virtuoso", false, [1,4,18,1], () => (__webpack_require__.e(5778).then(() => (() => (__webpack_require__(35778))))))),
	59048: () => (loadStrictVersion("default", "react-resizable-panels", false, [1,3,0,6], () => (__webpack_require__.e(3722).then(() => (() => (__webpack_require__(23722))))))),
	53989: () => (loadStrictVersion("default", "powerbi-client-react", false, [1,1,4,0], () => (__webpack_require__.e(3164).then(() => (() => (__webpack_require__(93164))))))),
	3673: () => (loadStrictVersion("default", "sanitize-html", false, [1,2,15,0], () => (Promise.all([__webpack_require__.e(4728), __webpack_require__.e(7172)]).then(() => (() => (__webpack_require__(74728)))))))
};
var initialConsumes = [92769,59783,19655,40565];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"2334": [
		3673
	],
	"3048": [
		2054,
		3701,
		12955,
		27163,
		30431,
		37137,
		48173,
		53638,
		54673,
		63345,
		67868,
		78626,
		78721,
		86843,
		87242,
		98283
	],
	"3824": [
		13824
	],
	"3864": [
		6883,
		82129
	],
	"3989": [
		53989
	],
	"4249": [
		14249
	],
	"4333": [
		59048
	],
	"4646": [
		64646
	],
	"4905": [
		54905
	],
	"7172": [
		37172
	],
	"7586": [
		57586
	],
	"8792": [
		92769,
		59783,
		19655,
		40565
	],
	"9771": [
		89771
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}